var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommentList',{attrs:{"title":_vm.$t('dispute.history.title'),"comments":_vm.compBookingHistoryComments},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_c('DisputeDialogBookingHistorySubmissionAlert')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }